import { createStore } from 'zustand'

import {
  createSitePromotionCoreSliceFactory,
  persistInMemoryCoreKeys,
} from '../_factory/core'

import type {
  PromotionCoreConfig,
  PromotionKey,
  SitePromotionCoreSlice,
} from '../_factory/core'

export interface PromotionPopupConfig extends PromotionCoreConfig {}

export type PromotionPopups = Record<string, PromotionPopupConfig>

export type PromotionPopupKey<T extends PromotionPopups> = PromotionKey<T>

export interface SitePromotionPopupsSlice {}

const persistInMemoryKeys = [...persistInMemoryCoreKeys] as const
const persistInMemoryData: Record<string, any> = {}

export function createPopupsStore<T extends PromotionPopups>(promotions: T) {
  const store = createStore<
    SitePromotionCoreSlice<T> & SitePromotionPopupsSlice
  >()((...a) => {
    const [set, get] = a

    const createSitePromotionCoreSlice = createSitePromotionCoreSliceFactory<
      T,
      SitePromotionPopupsSlice
    >(
      {
        closed: false,
        openKey: null,
        initKeys: [],
        promotions,
      },
      {
        cachePrefix: 'popups',
      },
    )

    return {
      ...createSitePromotionCoreSlice(...a),
      ...persistInMemoryData,
    }
  })

  store.subscribe((state) => {
    for (const key of persistInMemoryKeys) {
      persistInMemoryData[key] = state[key]
    }
  })

  return store
}
